import React from 'react';
import { useTranslation } from 'react-i18next';
import AnimatedElement from '../AnimatedElement';
import './ProjectCompletionOverlay.css';

/**
 * Overlay component that displays when a project is marked as completed
 * @param {Object} props - Component props
 * @param {string} props.projectName - Name of the completed project
 * @returns {React.ReactElement}
 */
const ProjectCompletionOverlay = ({ projectName }) => {
  const { t } = useTranslation();

  // Extract just the project name without the welcome part
  const extractProjectName = (fullTitle) => {
    // For Swedish: "Välkommen till Tomasliden" -> "Tomasliden"
    // For English: "Welcome to Tomasliden" -> "Tomasliden"
    const svMatch = fullTitle.match(/Välkommen till (.+)/i);
    const enMatch = fullTitle.match(/Welcome to (.+)/i);

    if (svMatch && svMatch[1]) return svMatch[1];
    if (enMatch && enMatch[1]) return enMatch[1];

    return fullTitle;
  };

  const cleanProjectName = extractProjectName(projectName);

  return (
    <div className="project-completion-overlay">
      <AnimatedElement type="fade-in" duration="700" className="project-completion-content">
        <div className="project-completion-badge">
          <span className="completion-check">✓</span>
        </div>
        <h2 className="project-completion-title">
          {t('components.ProjectCompletionOverlay.title')}
        </h2>
        <p className="project-completion-message">
          {t('components.ProjectCompletionOverlay.message', { projectName: cleanProjectName })}
        </p>
      </AnimatedElement>
    </div>
  );
};

export default ProjectCompletionOverlay;
